module.exports = __webpack_public_path__ + "shipzone.png?a40c2c64e8d8ead75d41af48d079de03";


//////////////////
// WEBPACK FOOTER
// ./assets/images/shipzone.png
// module id = 452
// module chunks = 0